import { defineCollection } from "@rebasepro/cms-types";
import { personName, playerOf } from "../people";

// A friend request not answered yet (songbuzz_friend_ask). backend/src/friends.ts creates and writes it.
const friendRequestsCollection = defineCollection({
    name: "Friend requests",
    singularName: "Friend request",
    slug: "friend_requests",
    table: "songbuzz_friend_ask",
    description: "Friend requests waiting for an answer.",
    securityRules: [
        { operation: "select", roles: ["admin"] },
        { operation: "delete", roles: ["admin"] },
    ],
    properties: {
        fromWho: { name: "From (id)", type: "string", isId: "manual", admin: { readOnly: true, hideFromCollection: true } },
        toWho: { name: "To (id)", type: "string", isId: "manual", admin: { readOnly: true, hideFromCollection: true } },
        from: playerOf("From", "fromWho", "from"),
        to: playerOf("To", "toWho", "to"),
        game: { name: "Met in room", type: "string", admin: { readOnly: true } },
        at: { name: "Sent", type: "date", autoValue: "on_create", validation: { required: true }, admin: { readOnly: true } },
    },
    admin: {
        icon: "UserPlus",
        group: "System",
        openEntityMode: "side_panel",
        sort: ["at", "desc"],
        display: {
            title: async ({ entity, context }) => `${await personName(context, entity.values.fromWho)} → ${await personName(context, entity.values.toWho)}`,
            date: "at",
        },
        listProperties: ["game", "at"],
        form: {
            sections: [
                { key: "request", properties: ["from", "to", "game", "at"] },
                { key: "ids", title: "Behind the scenes", collapsed: true, properties: ["fromWho", "toWho"] },
            ],
        },
    },
});

export default friendRequestsCollection;
